export default class StickyMenu {
	private readonly navHeight: number;
	private readonly customClass: string;

	constructor(private readonly nav: HTMLElement, customClass?: string) {
		this.navHeight = nav.offsetHeight;
		this.customClass = customClass || '';

		this.handleScroll = this.handleScroll.bind(this);
		window.addEventListener('load', this.handleScroll);
		window.addEventListener('scroll', this.handleScroll);

		nav.style.display = 'none';

		this.applyCustomClass();
	}

	private handleScroll() {
		const yOffset = window.pageYOffset;
		if (yOffset >= this.navHeight) {
			document.body.classList.add('stickyMenu');
			this.nav.style.display = 'block';
		} else {
			document.body.classList.remove('stickyMenu');
			this.nav.style.display = 'none';
		}
	}

	private applyCustomClass() {
		if (this.customClass) {
			this.nav.classList.add(this.customClass);
		}
	}

	destroy() {
		window.removeEventListener('load', this.handleScroll);
		window.removeEventListener('scroll', this.handleScroll);
		this.nav.classList.remove(this.customClass);
	}
}
